// 用于格式化当前时间
function timeFormat(date = 0, fmt = "yyyy-MM-dd hh:mm:ss") {
  date = new Date(+date);
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
      );
    }
  }
  return fmt;
}
function getDuration(mss) {
  var days = parseInt(mss / (1000 * 60 * 60 * 24));
  var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = (mss % (1000 * 60)) / 1000;
  console.log(
    days + " 天 " + hours + " 小时 " + minutes + " 分钟 " + seconds + " 秒 "
  );
  // return days + " 天 " + hours + " 小时 " + minutes + " 分钟 " + seconds + " 秒 ";
  return days + " 天 ";
}
export default {
  timeFormat,
  getDuration
};
